import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import Header from '../InitialPage/Sidebar/Header';
import Sidebar from '../InitialPage/Sidebar/Sidebar';
import { pagesRoute, posRoutes, publicRoutes } from './router.link';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ToastMessage from '../feature-module/components/toast-message';
import 'react-toastify/dist/ReactToastify.css';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import ProtectedRoute from '../core/utils/ProtectedRoute';
import AutoLogout from '../core/utils/AutoLogout';
import { all_routes } from './all_routes';
import { isAuthenticated } from '../core/utils/tokenUtils';
import { getAllowedModules, MODULES } from '../core/utils/roleBasedAccess';

import AuthCallback from '../auth/AuthCallback';

const AllRoutes = () => {
  const HeaderLayout = () => {
    const headerVisible = useSelector(isHeaderVisible);

    return (
      <div className={`main-wrapper ${headerVisible ? '' : 'header-collapse'}`}>
        <Header />
        <Sidebar />
        <AutoLogout />
        <Outlet />
      </div>
    );
  };

  const Authpages = () => {
    const headerVisible = useSelector(isHeaderVisible);
    return (
      <div className={headerVisible ? '' : 'header-collapse'}>
        <Outlet />
      </div>
    );
  };

  const Pospages = () => {
    const headerVisible = useSelector(isHeaderVisible);

    return (
      <div className={`main-wrapper ${headerVisible ? '' : 'header-collapse'}`}>
        <Header />
        <Sidebar />
        <AutoLogout />
        <Outlet />
        <ToastMessage />
      </div>
    );
  };

  // Root redirect component that checks auth status
  const RootRedirect = () => {
    const { accounts } = useMsal();
    // Force re-check of authentication status on render
    const authenticated = isAuthenticated();
    const msalAuthenticated = accounts && accounts.length > 0;

    console.log('RootRedirect: Checking auth status', {
      authenticated,
      msalAuthenticated,
      accountCount: accounts?.length,
      loginInfoExists: !!localStorage.getItem('LoginInfo'),
      tokenExists: !!localStorage.getItem('Token')
    });

    if (authenticated || msalAuthenticated) {
      // Redirect based on user role
      let userRoles = [];
      try {
        const raw = sessionStorage.getItem('MSAL_LAST_IDTOKEN_CLAIMS');
        if (raw) {
          const claims = JSON.parse(raw);
          userRoles = Array.isArray(claims?.roles) ? claims.roles : [];
        }
      } catch (_err) {
        console.error('RootRedirect: Error parsing MSAL claims:', _err);
      }

      console.log('RootRedirect: User roles found', userRoles);

      const allowedModules = getAllowedModules(userRoles);
      console.log('RootRedirect: Allowed modules', allowedModules);

      if (allowedModules.includes(MODULES.ADMIN_DASHBOARD)) {
        console.log('RootRedirect: Redirecting to Admin Dashboard');
        return <Navigate to={all_routes.dashboard} replace />;
      }
      if (allowedModules.includes(MODULES.WMS)) {
        console.log('RootRedirect: Redirecting to WMS (Shipment Tile)');
        return <Navigate to={all_routes.shipmenttile} replace />;
      }
      if (allowedModules.includes(MODULES.PPMS)) {
        console.log('RootRedirect: Redirecting to PPMS (Production)');
        return <Navigate to={all_routes.production} replace />;
      }
      if (allowedModules.includes(MODULES.QMS)) {
        console.log('RootRedirect: Redirecting to QMS (Inspection Plan Tile)');
        return <Navigate to={all_routes.inspectionplantile} replace />;
      }
      if (allowedModules.includes(MODULES.MMS)) {
        console.log('RootRedirect: Redirecting to MMS (Mold Receiving)');
        return <Navigate to={all_routes.moldreceiving} replace />;
      }
      if (allowedModules.includes(MODULES.AMS)) {
        console.log('RootRedirect: Redirecting to AMS (Cell)');
        return <Navigate to={all_routes.cell} replace />;
      }
      if (allowedModules.includes(MODULES.CUSTOMER_DASHBOARD)) {
        console.log('RootRedirect: Redirecting to Customer Dashboard (Shipments)');
        return <Navigate to={all_routes.shipments} replace />;
      }

      // Default fallback if no specific module match found but authenticated
      console.log('RootRedirect: No specific module match, defaulting to Dashboard');
      return <Navigate to={all_routes.dashboard} replace />;
    }

    console.log('RootRedirect: Not authenticated (authenticated=false, msalAuthenticated=false), redirecting to Signin');
    return <Navigate to={all_routes.signin} replace />;
  };

  return (
    <div className="root-body">
      <Routes>
        {/* Auth Callback Route - Must be before RootRedirect */}
        <Route path={all_routes.authcallback} element={<AuthCallback />} />

        {/* Root route redirect based on auth */}
        <Route path="/" element={<RootRedirect />} />

        {/* Public routes (no auth required) */}
        <Route path={'/'} element={<Authpages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        {/* Protected routes (auth required) */}
        <Route path="/pos" element={
          <ProtectedRoute>
            <Pospages />
          </ProtectedRoute>
        }>
          {posRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        <Route path={'/'} element={
          <ProtectedRoute>
            <HeaderLayout />
          </ProtectedRoute>
        }>
          {publicRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
      <ToastMessage />
    </div>
  );
};
export default AllRoutes;
